import ClutchWidget from './ClutchWidget';

export default ClutchWidget;
